import baseApi from "../api/baseApi";

const courseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCoursesUserSide: builder.query({
      query: ({
        page = 1,
        search,
        category,
        ageGroup,
        level,
        courseEnrollementType,
      } = {}) => {
        const params = new URLSearchParams();
        params.set("page", String(page));

        if (search) params.set("search", search);
        if (category) params.set("category", category);
        if (ageGroup) params.set("ageGroup", ageGroup);
        if (level) params.set("level", level);
        if (courseEnrollementType) {
          params.set("courseEnrollementType", courseEnrollementType);
        }

        return {
          url: `/course/?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Courses"],
    }),
    getPublicCourseById: builder.query({
      query: (courseId) => ({
        url: `/public/courses/${courseId}`,
        method: "GET",
      }),
      providesTags: ["Courses"],
    }),
    getUserEnrollments: builder.query({
      query: () => ({
        url: "/enrollment/getUserEnrollments",
        method: "GET",
      }),
      providesTags: ["Enrollments"],
    }),
    getEnrolledCourseData: builder.query({
      query: (courseId) => ({
        url: `/enrollment/getEnrolledCourseData/${courseId}`,
        method: "GET",
      }),
      providesTags: ["Enrollments", "Courses"],
    }),
    checkEnrollmentStatus: builder.query({
      query: (courseId) => ({
        url: `/enrollment/checkEnrollmentStatus/${courseId}`,
        method: "GET",
      }),
      providesTags: ["Enrollments"],
    }),
    createEnrollment: builder.mutation({
      query: ({ courseId, formData }) => ({
        url: `/enrollment/createEnrollment/${courseId}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Enrollments"],
    }),
    getAvailableQuizzes: builder.query({
      query: () => ({
        url: "/studentquiz/getAvailableQuizzes",
        method: "GET",
      }),
      providesTags: ["Quizzes"],
    }),
  
    createCourseFeedback: builder.mutation({
      query: ({ courseId, feedbackText, rating }) => ({
        url: `/coursefeedback/createFeedback/${courseId}`,
        method: "POST",
        body: { feedbackText, rating },
      }),
    }),
    getCourseFeedbacks: builder.query({
      query: (courseId) => ({
        url: `/coursefeedback/getCourseFeedbacks/${courseId}`,
        method: "GET",
      }),
      providesTags: ["Courses"],
    }),
    getUserCourseFeedback: builder.query({
      query: (courseId) => ({
        url: `/coursefeedback/getUserCourseFeedback/${courseId}`,
        method: "GET",
      }),
      providesTags: ["Courses"],
    }),

    getCurrentUser: builder.query({
      query: () => ({
        url: "user/showCurrentUser",
        method: "GET",
      }),
      providesTags: ["User"],
    }),
  }),
});

export const {
  useGetAllCoursesUserSideQuery,
  useGetPublicCourseByIdQuery,
  useGetUserEnrollmentsQuery,
  useGetEnrolledCourseDataQuery,
  useCheckEnrollmentStatusQuery,
  useCreateEnrollmentMutation,
  useGetAvailableQuizzesQuery,

  useCreateCourseFeedbackMutation,
  useGetCourseFeedbacksQuery,
  useGetUserCourseFeedbackQuery,
} = courseApi;

export default courseApi;
